export default __webpack_public_path__ + "static/media/mulher.23f0eb57.JPG";